export default __webpack_public_path__ + "static/media/rabbitmq-logo.806ab537.svg";